export var devices = {
    mobileSmall: "320px",
    mobile: "425px",
    tablet: "768px",
    laptop: "1024px",
    laptopLarge: "1200px",
    desktop: "1440px",
    desktopLarge: "2560px",
};
export var breakpoints = {
    mobileSmall: "(min-width: ".concat(devices.mobileSmall, ")"),
    mobile: "(min-width: ".concat(devices.mobile, ")"),
    tablet: "(min-width: ".concat(devices.tablet, ")"),
    laptop: "(min-width: ".concat(devices.laptop, ")"),
    laptopLarge: "(min-width: ".concat(devices.laptopLarge, ")"),
    desktop: "(min-width: ".concat(devices.desktop, ")"),
    desktopLarge: "(min-width: ".concat(devices.desktopLarge, ")"),
};
